import * as pdfjs from 'pdfjs-dist/legacy/build/pdf.js';
// import pdfWorker from 'pdfjs-dist/legacy/build/pdf.worker.min.js';

// pdfjs.GlobalWorkerOptions.workerSrc =
//   '//unpkg.com/pdfjs-dist@' + pdfjs.version + '/build/pdf.worker.min.js';

pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.js';

export function loadPdf(url) {
  return pdfjs.getDocument(url).promise;
}

export function renderPdfPage(page, scale) {
  const viewport = page.getViewport({ scale });
  const canvas = document.createElement('canvas');

  canvas.width = viewport.width;
  canvas.height = viewport.height;

  return page
    .render({
      canvasContext: canvas.getContext('2d'),
      viewport,
    })
    .promise.then(() => {
      return { canvas, viewport };
    });
}
